import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-change-user',
	templateUrl: './icon-change-user.component.svg',
})
export class IconChangeUserComponent {}
